import type { JSX } from 'react';
import type { WireArtifact } from '@logistics/contracts';
import { artifactGlyph, artifactKindLabel, artifactTitle } from './artifacts/artifact-meta';

/** The card under an answer that opens its artifact in the side panel. */
export function ArtifactCard({
  artifact,
  showing,
  onOpen,
}: {
  artifact: WireArtifact;
  showing: boolean;
  onOpen: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="bg-bg hover:border-acc grid w-full max-w-[420px] grid-cols-[36px_minmax(0,1fr)_auto] items-center gap-3 rounded-xl border px-3.5 py-3 text-left text-inherit transition-colors"
      style={{ borderColor: showing ? 'var(--acc)' : undefined }}
    >
      <span className="bg-acc-soft text-acc grid size-9 place-items-center rounded-[9px] font-mono text-[10px] font-medium">
        {artifactGlyph(artifact)}
      </span>
      <span className="min-w-0">
        <span className="block truncate text-[13.5px] font-medium">{artifactTitle(artifact)}</span>
        <span className="text-mute mt-px block text-xs">{artifactKindLabel(artifact)}</span>
      </span>
      <span className="text-acc text-xs whitespace-nowrap">{showing ? 'Showing' : 'Open →'}</span>
    </button>
  );
}
